import React, { useState } from 'react';
import { List, ListItem, ListItemText, Box, ThemeProvider, Autocomplete, createTheme, TextField } from '@mui/material';
import { useLoaderData } from 'react-router-dom';

function ListItemLink(props) {
  return <ListItem button component="a" {...props} />;
}

const theme = createTheme();

const formatZones = (zones) => {
  return zones.map((zone) => {
    return {
      city_id: zone.city_id,
      name: `${zone.city}, ${zone.department}`,
      url: `${zone.department_alias}/${zone.city_alias}`
    };
  });
};

function Zones() {
  const zones = useLoaderData();
  const zonesFormatted = formatZones(zones);
  const [zonesFiltered, setZonesFiltered] = useState([...zonesFormatted]);
  zonesFormatted.unshift({ city_id: 0, name: 'Toda Colombia', url: '' });

  const zoneOnChange = (event, zone) => {
    if(!zone || zone.city_id === 0){
      setZonesFiltered([...zonesFormatted.slice(1)]);
    }
    else{
      setZonesFiltered(
        zonesFormatted.filter((z) =>
          z.city_id === zone.city_id));
    }
  };

  return (
    <div className='container'>
      <ThemeProvider theme={theme}>
        <div className="container-departamento-ciudad zone-list">
          <p>¿En dónde te encuentras?</p>
          <div className="custom-search-box">
            <Autocomplete
              disablePortal
              id="dropdown-departamento-y-municipio"
              options={zonesFormatted}
              getOptionLabel={(option) => option.name}
              sx={{ width: 300 }}
              renderInput={(params) => <TextField {...params} variant="outlined" label="Ubicación" />}
              className='input-correct'
              onChange={zoneOnChange}
            />
          </div>
        </div>
        <Box sx={{ width: '100%', bgcolor: 'background.paper' }}>
          <nav>
            <List>
              {zonesFiltered.map((point, index) => (
                <ListItemLink href={point.url}>
                  <ListItemText primary={point.name} />
                </ListItemLink>
              ))}
            </List>
          </nav>
        </Box>
      </ThemeProvider>
    </div>
  );
}

export default Zones;
